import { render, staticRenderFns } from "./shareMiniProgram.vue?vue&type=template&id=167f1c3f&scoped=true"
import script from "./shareMiniProgram.vue?vue&type=script&lang=js"
export * from "./shareMiniProgram.vue?vue&type=script&lang=js"
import style0 from "./shareMiniProgram.vue?vue&type=style&index=0&id=167f1c3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f1c3f",
  null
  
)

export default component.exports